module.exports = __webpack_public_path__ + "img/twitter_icon_black.470b2f12.svg";